import React from 'react'
import img2 from "../assets/images/Group1.png"
import img3 from "../assets/images/Group2.png"
import img4 from "../assets/images/Group3.png"
import Header2 from '../Layout/Header2'

export default function HowitsWork() {
    return (
        <div>
            <Header2 />
            <section className="section bg-gradient-new pricing" id="pricing">
                <div className="bg-shape" />
                <div className="container">
                    <div className="row gy-5 justify-content-center">
                        <div className="col-lg-10">
                            <div className="text-center">
                                <p className="whychoose">How it Works</p>
                                <p className="craftw"> Capture professional hyper-realistic portrait photos,
                                    ideal for your Linkedin or other socials, marketing, or simply for private use.</p>
                            </div>
                        </div>
                    </div>

                    {/* End col */}
                    <div className="row gy-5 justify-content-center mt-2">
                        <div className="col-lg-4 col-md-6">
                            <div className="card22  mx-1" >
                                <div className="text-center mt-3">
                                    <img src={img3} alt='' style={{ width: "90%" }} />
                                </div>
                                <div className="text-center mt-2 px-2">
                                    <p className='nomore'>Upload your selfies</p>
                                    <p className="craft">Upload at least 20 images of your face.</p>
                                </div>
                            </div>
                            {/* End card */}
                        </div>
                        {/* end col */}
                        <div className="col-lg-4 col-md-6">
                            <div className=" card22 " >
                                <div className=" text-center mt-3">
                                    <img src={img4} alt='' style={{ width: "90%" }} />
                                </div>
                                <div className="text-center mt-2 px-2">
                                    <p className='nomore'>Let AI work its magic</p>
                                    <p className="craft">We create custom AI headshots within 5 minutes.</p>
                                </div>
                            </div>
                            {/* End card */}
                        </div>
                        {/* col end */}
                        <div className="col-lg-4 col-md-6">
                            <div className="card22 " >
                                <div className="text-center mt-3">
                                    <img src={img2} alt='' style={{ width: "90%" }} />
                                </div>
                                <div className="text-center mt-2 px-2">
                                    <p className='nomore1'>Download AI headshots</p>
                                    <p className="craft">Review and download  your favourite headshots from a collection of  100+.</p>
                                </div>
                            </div>
                            {/* End card */}
                        </div>
                        {/* col end */}
                    </div>
                    {/* End row */}
                </div>
                {/* End container */}
            </section>
            {/* <Footer/> */}
        </div>
    )
}